module.exports = __webpack_public_path__ + "img/cards2_b.740d4b48.svg";